import { render, staticRenderFns } from "./Org.vue?vue&type=template&id=2e825ff9&scoped=true"
import script from "./Org.vue?vue&type=script&lang=js"
export * from "./Org.vue?vue&type=script&lang=js"
import style0 from "./Org.vue?vue&type=style&index=0&id=2e825ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e825ff9",
  null
  
)

export default component.exports